import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from '../components/PageTitle';
import { IconMail, IconWand } from '@tabler/icons-react';
import '../styles/HomePage.css';

export function HomePage() {
  const [localPart, setLocalPart] = useState('');
  const navigate = useNavigate();

  const handleView = () => {
    if (localPart.trim()) {
      navigate(`/inbox/${localPart.toLowerCase()}@ephemail.space`);
    }
  };

  const handleGenerate = () => {
    navigate('/generated');
  };


  return (
    <>
      <PageTitle title="Disposable. Powerful. Ephemail." />
      <div className="home-container">
        <div className="email-input-wrapper">
          <input
            className="email-input"
            type="text"
            placeholder="Enter address"
            value={localPart}
            onChange={(e) => {
              const value = e.target.value;
              const atIndex = value.indexOf('@');
              setLocalPart(atIndex !== -1 ? value.slice(0, atIndex) : value);
            }}
          />
          <div className="email-domain">@ephemail.space</div>
        </div>

        <div className="home-buttons">
          <button className="btn view-btn" onClick={handleView}>
            <IconMail size={30} />
            View Email
          </button>

          <button className="btn generate-btn" onClick={handleGenerate}>
            <IconWand size={30} />
            Generate
          </button>
        </div>

        <div className="home-description-box">
          <ul className="home-description">
            <li>This is a temporary email service.</li>
            <li>Each email is available for 30 minutes and then is permanently deleted.</li>
            <li>This service is completely free.</li>
            <li>Please use it responsibly and avoid sharing confidential or illegal information.</li>
          </ul>
        </div>
      </div>
    </>
  );
}
